import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-contractor-dashboard-group-row',
  templateUrl: './contractor-dashboard-group-row.component.html',
  styleUrls: ['./contractor-dashboard-group-row.component.css']
})
export class ContractorDashboardGroupRowComponent  implements ICellRendererAngularComp {


  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return true;
  }

  toggleRow(rowData) {
    const rowDataMaster = this.params.context.componentParent.rowData;
    const rowIndex = this.params.rowIndex + 1;
    let index = rowIndex;
    while (rowDataMaster[index] && rowData.groupLevel !== rowDataMaster[index].groupLevel) {
      const element = rowDataMaster[index];
      element.isVisible = !element.isVisible;
      index++;
    }
    this.params.context.componentParent.rowData = rowDataMaster;
    this.params.api.onFilterChanged();
  }

}
